import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { DP_FGTS_PAGE, DP_INSS_PAGE } from "../routes";

/**
 * Abas de Recolhimentos: uma rota por guia, para cada uma ter link próprio.
 * A aba ativa sai da rota atual.
 */
export default function RecolhimentosTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const tabs = [
    { label: "FGTS", path: DP_FGTS_PAGE() },
    { label: "INSS", path: DP_INSS_PAGE() },
  ];

  return (
    <nav className="dpTabs">
      {tabs.map((tab) => (
        <button
          key={tab.path}
          type="button"
          className={`dpTab ${pathname === tab.path ? "is-active" : ""}`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
